import { CreateContact } from 'smg/customer-api/contact';
import { Session } from 'smg/customer-api/session';
import Modal from 'smg/modal';
import * as models from 'smg/models';
import { Phone } from 'smg/phone';
import * as template from 'smg/template';

declare interface promptQuantityChangeOptions {
    quote?: models.Quote;
    order?: models.Order;
    lineItem: models.QuoteLineItem | models.OrderLineItem;
}

export async function PromptQuantityChange(opts: promptQuantityChangeOptions): Promise<void> {
    const body = template.Clone('#custom-qty-modal');
    const fullName = body.querySelector('#modal-full-name') as HTMLInputElement;
    const email = body.querySelector('#modal-email') as HTMLInputElement;
    const phone = body.querySelector('#modal-phone') as HTMLInputElement;
    const quantity = body.querySelector('#modal-quantity') as HTMLInputElement;
    const message = body.querySelector('#modal-message') as HTMLTextAreaElement;

    const sess = await Session().catch(() => undefined);
    if (sess) {
        fullName.value = `${sess.firstName} ${sess.lastName}`;
        email.value = sess.email;
        phone.value = sess.phone;
    }

    const p = new Phone(phone);

    let quoteLineItemIndex: number = 0;
    let orderLineItemIndex: number = 0;
    if (opts.quote?.quoteLineItems) {
        quoteLineItemIndex = opts.quote.quoteLineItems.indexOf(opts.lineItem) + 1;
    } else if (opts.order?.orderLineItems) {
        orderLineItemIndex = opts.order.orderLineItems?.indexOf(opts.lineItem) + 1;
    }

    const $reCaptchaPlaceholder = body.querySelector('#modal-recaptcha') as HTMLElement;

    return new Promise(resolve => new Modal({
        title: 'Change Quantity Request',
        body,
        onSubmit: async () => {
            const postMessage = `Qty update request for ${opts.quote ? 'quote' : 'order'} #${opts.quote ? opts.quote.serial || '' : opts.order?.invoiceNumber || ''}

            New quantity requested: ${quantity.value}
            For line item #${opts.quote?.quoteLineItems ? quoteLineItemIndex : orderLineItemIndex}

            Other comments:
            ${message.value.trim() || 'None'}`;

            await CreateContact({
                name: fullName.value,
                company: '',
                phone: p,
                email: email.value,
                content: postMessage,
                ignoreSMSPreference: true,
                $reCaptchaPlaceholder,
            }).then(() => resolve());
        },
    }));
}